"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var getCridClasses = function getCridClasses(amount) {
  switch (amount) {
    case 1:
      return 'col-xs-12';

    case 2:
      return 'col-xs-12 col-sm-6';

    case 3:
      return 'col-xs-12 col-md-4';

    case 4:
      return 'col-xs-12 col-md-6 col-lg-3';

    case 6:
      return 'col-xs-12 col-sm-4 col-lg-2';

    case 12:
      return 'col-xs-12 col-sm-1';

    default:
      return 'col-xs-12';
  }
};

var TeaserContainer = function TeaserContainer(props) {
  var rowClassNames = (0, _classnames.default)('teaser-container', 'row', 'flex-sm flex-wrap-sm', props.className && props.className);
  var columnClassNames;

  if (props.teaserPerRow) {
    columnClassNames = "".concat(getCridClasses(props.teaserPerRow));
  } else {
    var childCount = props.children.length || 1;
    columnClassNames = (0, _classnames.default)(getCridClasses(childCount));
  }

  var aggregartedColumnClassNames = (0, _classnames.default)(columnClassNames, props.columnClassName && props.columnClassName);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rowClassNames
  }, _react.default.Children.map(props.children, function (child) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: aggregartedColumnClassNames
    }, child);
  }));
};

TeaserContainer.defaultValue = {
  children: []
};
TeaserContainer.propTypes = {
  teaserPerRow: _propTypes.default.PropTypes.oneOf([1, 2, 3, 4, 6, 12]),
  className: _propTypes.default.string,
  columnClassName: _propTypes.default.string
};
var _default = TeaserContainer;
exports.default = _default;